/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Money } from './Money';
import {
    MoneyFromJSON,
    MoneyFromJSONTyped,
    MoneyToJSON,
} from './Money';
import type { PaymentOperation } from './PaymentOperation';
import {
    PaymentOperationFromJSON,
    PaymentOperationFromJSONTyped,
    PaymentOperationToJSON,
} from './PaymentOperation';
import type { PaymentTransactionId } from './PaymentTransactionId';
import {
    PaymentTransactionIdFromJSON,
    PaymentTransactionIdFromJSONTyped,
    PaymentTransactionIdToJSON,
} from './PaymentTransactionId';

/**
 * 
 * @export
 * @interface PaymentReturnModel
 */
export interface PaymentReturnModel {
    /**
     * 
     * @type {string}
     * @memberof PaymentReturnModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentReturnModel
     */
    provider?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentReturnModel
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {Money}
     * @memberof PaymentReturnModel
     */
    amount?: Money;
    /**
     * 
     * @type {{ [key: string]: string | undefined | null; }}
     * @memberof PaymentReturnModel
     */
    readonly fields?: { [key: string]: string | undefined | null; };
    /**
     * 
     * @type {Array<PaymentOperation>}
     * @memberof PaymentReturnModel
     */
    readonly paymentOperations?: Array<PaymentOperation>;
    /**
     * 
     * @type {PaymentTransactionId}
     * @memberof PaymentReturnModel
     */
    transactionId?: PaymentTransactionId;
    /**
     * 
     * @type {Money}
     * @memberof PaymentReturnModel
     */
    fee?: Money;
    /**
     * 
     * @type {Date}
     * @memberof PaymentReturnModel
     */
    readonly created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PaymentReturnModel
     */
    readonly completed?: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentReturnModel
     */
    paymentState?: string;
    /**
     * 
     * @type {Money}
     * @memberof PaymentReturnModel
     */
    amountCaptured?: Money;
    /**
     * 
     * @type {Money}
     * @memberof PaymentReturnModel
     */
    amountRefunded?: Money;
}

/**
 * Check if a given object implements the PaymentReturnModel interface.
 */
export function instanceOfPaymentReturnModel(value: object): boolean {
    return true;
}

export function PaymentReturnModelFromJSON(json: any): PaymentReturnModel {
    return PaymentReturnModelFromJSONTyped(json, false);
}

export function PaymentReturnModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentReturnModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'provider': json['provider'] == null ? undefined : json['provider'],
        'paymentMethodId': json['paymentMethodId'] == null ? undefined : json['paymentMethodId'],
        'amount': json['amount'] == null ? undefined : MoneyFromJSON(json['amount']),
        'fields': json['fields'] == null ? undefined : json['fields'],
        'paymentOperations': json['paymentOperations'] == null ? undefined : ((json['paymentOperations'] as Array<any>).map(PaymentOperationFromJSON)),
        'transactionId': json['transactionId'] == null ? undefined : PaymentTransactionIdFromJSON(json['transactionId']),
        'fee': json['fee'] == null ? undefined : MoneyFromJSON(json['fee']),
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'completed': json['completed'] == null ? undefined : (new Date(json['completed'])),
        'paymentState': json['paymentState'] == null ? undefined : json['paymentState'],
        'amountCaptured': json['amountCaptured'] == null ? undefined : MoneyFromJSON(json['amountCaptured']),
        'amountRefunded': json['amountRefunded'] == null ? undefined : MoneyFromJSON(json['amountRefunded']),
    };
}

export function PaymentReturnModelToJSON(value?: Omit<PaymentReturnModel, 'fields'|'paymentOperations'|'created'|'completed'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'provider': value['provider'],
        'paymentMethodId': value['paymentMethodId'],
        'amount': MoneyToJSON(value['amount']),
        'transactionId': PaymentTransactionIdToJSON(value['transactionId']),
        'fee': MoneyToJSON(value['fee']),
        'paymentState': value['paymentState'],
        'amountCaptured': MoneyToJSON(value['amountCaptured']),
        'amountRefunded': MoneyToJSON(value['amountRefunded']),
    };
}

